import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';
import dataPrivacyInfoPdf from '../../docs/Informationen_zum_Datenschutz-Luz-V4.pdf';

const DataPrivacy = () => {
  return (
    <div className='data-privacy' id='dataPrivacy'>
      <Container>
        <Row>
          <Col xs={12}>
            <h1 className='h1'>Datenschutzerklärung</h1>

            <div className='d-flex flex-row align-items-center justify-content-start my-3'>
              <FontAwesomeIcon icon={faFilePdf} size='2x' className='text-danger' />
              <p className='p ms-2 mb-0'>
                <a href={dataPrivacyInfoPdf} target='_blank' rel='noreferrer noopener'>
                  Informationsblatt zum Datenschutz
                </a>
              </p>
            </div>

            <p className='p'>
              Personenbezogene Daten (nachfolgend zumeist nur „Daten“ genannt) werden von uns nur im Rahmen der
              Erforderlichkeit sowie zum Zwecke der Bereitstellung eines funktionsfähigen und nutzerfreundlichen
              Internetauftritts, inklusive seiner Inhalte und der dort angebotenen Leistungen, verarbeitet.
            </p>
            <p className='p'>
              Gemäß Art. 4 Ziffer 1. der Verordnung (EU) 2016/679, also der Datenschutz-Grundverordnung (nachfolgend nur
              „DSGVO“ genannt), gilt als „Verarbeitung“ jeder mit oder ohne Hilfe automatisierter Verfahren ausgeführter
              Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten, wie das Erheben, das
              Erfassen, die Organisation, das Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das
              Abfragen, die Verwendung, die Offenlegung durch Übermittlung, Verbreitung oder eine andere Form der
              Bereitstellung, den Abgleich oder die Verknüpfung, die Einschränkung, das Löschen oder die Vernichtung.
            </p>
            <p className='p'>
              Mit der nachfolgenden Datenschutzerklärung informieren wir Sie insbesondere über Art, Umfang, Zweck, Dauer
              und Rechtsgrundlage der Verarbeitung personenbezogener Daten, soweit wir entweder allein oder gemeinsam
              mit anderen über die Zwecke und Mittel der Verarbeitung entscheiden. Zudem informieren wir Sie nachfolgend
              über die von uns zu Optimierungszwecken sowie zur Steigerung der Nutzungsqualität eingesetzten
              Fremdkomponenten, soweit hierdurch Dritte Daten in wiederum eigener Verantwortung verarbeiten.
            </p>
            <p className='p'>Unsere Datenschutzerklärung ist wie folgt gegliedert:</p>
            <ol className='ol roman'>
              <li className='li'>Informationen über uns als Verantwortliche</li>
              <li className='li'>Rechte der Nutzer und Betroffenen</li>
              <li className='li'>Informationen zur Datenverarbeitung</li>
            </ol>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h2'>I. Informationen über uns als Verantwortliche</h2>
            <p className='p'>Verantwortlicher Anbieter dieses Internetauftritts im datenschutzrechtlichen Sinne ist:</p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <address className='p'>
              <span className='desc'>Notarin Yvonne Luz</span> <br />
              Carré Bad Cannstatt <br />
              Kreuznacher Str. 68 <br />
              70372 Stuttgart <br />
              Deutschland
            </address>

            <p className='p email'>
              <span className='desc'>E-Mail:</span> info@ll-notare.de
            </p>
            <p className='p telephone'>
              <span className='desc'>Telefon:</span> +49 (0)711 955926-0
            </p>
            <p className='p fax'>
              <span className='desc'>Telefax:</span> +49 (0)711 955926-99
            </p>

            <p className='p'>
              Der betriebliche Datenschutzbeauftragte von Notarin Yvonne Luz und Herrn Maximilian Schilling ist Herr
              Hubert Rommel, Kapellenstraße 56, 88471 Laupheim; er ist direkt unter datenschutz@ll-notare.de erreichbar.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h2'>II. Rechte der Nutzer und Betroffenen</h2>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <p className='p'>
              Mit Blick auf die nachfolgend noch näher beschriebene Datenverarbeitung haben die Nutzer und Betroffenen
              das Recht
            </p>
            <ul className='ul'>
              <li className='li'>
                auf Bestätigung, ob sie betreffende Daten verarbeitet werden, auf Auskunft über die verarbeiteten Daten,
                auf weitere Informationen über die Datenverarbeitung sowie auf Kopien der Daten (vgl. auch Art. 15
                DSGVO);
              </li>
              <li className='li'>
                auf Berichtigung oder Vervollständigung unrichtiger bzw. unvollständiger Daten (vgl. auch Art. 16
                DSGVO);
              </li>
              <li className='li'>
                auf unverzügliche Löschung der sie betreffenden Daten (vgl. auch Art. 17 DSGVO), oder, alternativ,
                soweit eine weitere Verarbeitung gemäß Art. 17 Abs. 3 DSGVO erforderlich ist, auf Einschränkung der
                Verarbeitung nach Maßgabe von Art. 18 DSGVO;
              </li>
              <li className='li'>
                auf Erhalt der sie betreffenden und von ihnen bereitgestellten Daten und auf Übermittlung dieser Daten
                an andere Anbieter/Verantwortliche (vgl. auch Art. 20 DSGVO);
              </li>
              <li className='li'>
                auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie der Ansicht sind, dass die sie betreffenden
                Daten durch den Anbieter unter Verstoß gegen datenschutzrechtliche Bestimmungen verarbeitet werden (vgl.
                auch Art. 77 DSGVO).
              </li>
            </ul>
            <p className='p desc'>Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:</p>
            <ul className='ul'>
              <li className='li'>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website,</li>
              <li className='li'>Gewährleistung einer komfortablen Nutzung unserer Website,</li>
              <li className='li'>Auswertung der Systemsicherheit und -stabilität sowie</li>
              <li className='li'>zu weiteren administrativen Zwecken.</li>
            </ul>
            <p className='p'>
              Darüber hinaus ist der Anbieter dazu verpflichtet, alle Empfänger, denen gegenüber Daten durch den
              Anbieter offengelegt worden sind, über jedwede Berichtigung oder Löschung von Daten oder die Einschränkung
              der Verarbeitung, die aufgrund der Artikel 16, 17 Abs. 1, 18 DSGVO erfolgt, zu unterrichten. Diese
              Verpflichtung besteht jedoch nicht, soweit diese Mitteilung unmöglich oder mit einem unverhältnismäßigen
              Aufwand verbunden ist. Unbeschadet dessen hat der Nutzer ein Recht auf Auskunft über diese Empfänger.
            </p>
            <p className='p'>
              Ebenfalls haben die Nutzer und Betroffenen nach Art. 21 DSGVO das Recht auf Widerspruch gegen die künftige
              Verarbeitung der sie betreffenden Daten, sofern die Daten durch den Anbieter nach Maßgabe von Art. 6 Abs.
              1 lit. f) DSGVO verarbeitet werden. Insbesondere ist ein Widerspruch gegen die Datenverarbeitung zum
              Zwecke der Direktwerbung statthaft.
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <h2 className='h2'>III. Informationen zur Datenverarbeitung</h2>
            <p className='p'>
              Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten werden gelöscht oder gesperrt, sobald der
              Zweck der Speicherung entfällt, der Löschung der Daten keine gesetzlichen Aufbewahrungspflichten
              entgegenstehen und nachfolgend keine anderslautenden Angaben zu einzelnen Verarbeitungsverfahren gemacht
              werden.
            </p>

            <div>
              <h3 className='h3'>Cookies</h3>
              <h4 className='h4'>a) Sitzungs-Cookies/Session-Cookies</h4>
              <p className='p'>
                Wir verwenden mit unserem Internetauftritt sog. Cookies. Cookies sind kleine Textdateien oder andere
                Speichertechnologien, die durch den von Ihnen eingesetzten Internet-Browser auf Ihrem Endgerät ablegt
                und gespeichert werden. Durch diese Cookies werden im individuellen Umfang bestimmte Informationen von
                Ihnen, wie beispielsweise Ihre Browser- oder Standortdaten oder Ihre IP-Adresse, verarbeitet.
              </p>
              <p className='p'>
                Durch diese Verarbeitung wird unser Internetauftritt benutzerfreundlicher, effektiver und sicherer, da
                die Verarbeitung bspw. die Wiedergabe unseres Internetauftritts in unterschiedlichen Sprachen oder das
                Angebot einer Warenkorbfunktion ermöglicht.
              </p>
              <p className='p'>
                Rechtsgrundlage dieser Verarbeitung ist Art. 6 Abs. 1 lit b.) DSGVO, sofern diese Cookies Daten zur
                Vertragsanbahnung oder Vertragsabwicklung verarbeitet werden.
              </p>
              <p className='p'>
                Falls die Verarbeitung nicht der Vertragsanbahnung oder Vertragsabwicklung dient, liegt unser
                berechtigtes Interesse in der Verbesserung der Funktionalität unseres Internetauftritts. Rechtsgrundlage
                ist in dann Art. 6 Abs. 1 lit. f) DSGVO.
              </p>
              <p className='p'>Mit Schließen Ihres Internet-Browsers werden diese Session-Cookies gelöscht.</p>

              <h4 className='h4'>b) Drittanbieter-Cookies</h4>
              <p className='p'>
                Gegebenenfalls werden mit unserem Internetauftritt auch Cookies von Partnerunternehmen, mit denen wir
                zum Zwecke der Werbung, der Analyse oder der Funktionalitäten unseres Internetauftritts
                zusammenarbeiten, verwendet.
              </p>
              <p className='p'>
                Die Einzelheiten hierzu, insbesondere zu den Zwecken und den Rechtsgrundlagen der Verarbeitung solcher
                Drittanbieter-Cookies, entnehmen Sie bitte den nachfolgenden Informationen.
              </p>

              <h4 className='h4'>c) Beseitigungsmöglichkeit</h4>
              <p className='p'>
                Sie können die Installation der Cookies durch eine Einstellung Ihres Internet-Browsers verhindern oder
                einschränken. Ebenfalls können Sie bereits gespeicherte Cookies jederzeit löschen. Die hierfür
                erforderlichen Schritte und Maßnahmen hängen jedoch von Ihrem konkret genutzten Internet-Browser ab. Bei
                Fragen benutzen Sie daher bitte die Hilfefunktion oder Dokumentation Ihres Internet-Browsers oder wenden
                sich an dessen Hersteller bzw. Support. Bei sog. Flash-Cookies kann die Verarbeitung allerdings nicht
                über die Einstellungen des Browsers unterbunden werden. Stattdessen müssen Sie insoweit die Einstellung
                Ihres Flash-Players ändern. Auch die hierfür erforderlichen Schritte und Maßnahmen hängen von Ihrem
                konkret genutzten Flash-Player ab. Bei Fragen benutzen Sie daher bitte ebenso die Hilfefunktion oder
                Dokumentation Ihres Flash-Players oder wenden sich an den Hersteller bzw. Benutzer-Support.
              </p>
              <p className='p'>
                Sollten Sie die Installation der Cookies verhindern oder einschränken, kann dies allerdings dazu führen,
                dass nicht sämtliche Funktionen unseres Internetauftritts vollumfänglich nutzbar sind.
              </p>
            </div>

            <div>
              <h3 className='h3'>Online-Stellenbewerbungen / Veröffentlichung von Stellenanzeigen</h3>
              <p className='p'>
                Wir bieten Ihnen die Möglichkeit an, sich bei uns über unseren Internetauftritt bewerben zu können. Bei
                diesen digitalen Bewerbungen werden Ihre Bewerber- und Bewerbungsdaten von uns zur Abwicklung des
                Bewerbungsverfahrens elektronisch erhoben und verarbeitet.
              </p>
              <p className='p'>
                Rechtsgrundlage für diese Verarbeitung ist § 26 Abs. 1 S. 1 BDSG i.V.m. Art. 88 Abs. 1 DSGVO.
              </p>
              <p className='p'>
                Sofern nach dem Bewerbungsverfahren ein Arbeitsvertrag geschlossen wird, speichern wir Ihre bei der
                Bewerbung übermittelten Daten in Ihrer Personalakte zum Zwecke des üblichen Organisations- und
                Verwaltungsprozesses – dies natürlich unter Beachtung der weitergehenden rechtlichen Verpflichtungen.
              </p>
              <p className='p'>
                Rechtsgrundlage für diese Verarbeitung ist ebenfalls § 26 Abs. 1 S. 1 BDSG i.V.m. Art. 88 Abs. 1 DSGVO.
              </p>
              <p className='p'>
                Bei der Zurückweisung einer Bewerbung löschen wir die uns übermittelten Daten automatisch zwei Monate
                nach der Bekanntgabe der Zurückweisung. Die Löschung erfolgt jedoch nicht, wenn die Daten aufgrund
                gesetzlicher Bestimmungen, bspw. wegen der Beweispflichten nach dem AGG, eine längere Speicherung von
                bis zu vier Monaten oder bis zum Abschluss eines gerichtlichen Verfahrens erfordern.
              </p>
              <p className='p'>
                Rechtsgrundlage ist in diesem Fall Art. 6 Abs. 1 lit. f) DSGVO und § 24 Abs. 1 Nr. 2 BDSG. Unser
                berechtigtes Interesse liegt in der Rechtsverteidigung bzw. -durchsetzung.
              </p>
              <p className='p'>
                Sofern Sie ausdrücklich in eine längere Speicherung Ihrer Daten einwilligen, bspw. für Ihre Aufnahme in
                eine Bewerber- oder Interessentendatenbank, werden die Daten aufgrund Ihrer Einwilligung
                weiterverarbeitet. Rechtsgrundlage ist dann Art. 6 Abs. 1 lit. a) DSGVO. Ihre Einwilligung können Sie
                aber natürlich jederzeit nach Art. 7 Abs. 3 DSGVO durch Erklärung uns gegenüber mit Wirkung für die
                Zukunft widerrufen.
              </p>
            </div>

            <div>
              <h3 className='h3'>Google-Maps</h3>
              <p className='p'>
                In unserem Internetauftritt setzen wir Google Maps zur Darstellung unseres Standorts sowie zur
                Erstellung einer Anfahrtsbeschreibung ein. Es handelt sich hierbei um einen Dienst der Google Ireland
                Limited, Gordon House, Barrow Street, Dublin 4, Irland, nachfolgend nur „Google“ genannt.
              </p>
              <p className='p'>
                Um die Darstellung bestimmter Schriften in unserem Internetauftritt zu ermöglichen, wird bei Aufruf
                unseres Internetauftritts eine Verbindung zu dem Google-Server in den USA aufgebaut.
              </p>
              <p className='p'>
                Sofern Sie die in unseren Internetauftritt eingebundene Komponente Google Maps aufrufen, speichert
                Google über Ihren Internet-Browser ein Cookie auf Ihrem Endgerät. Um unseren Standort anzuzeigen und
                eine Anfahrtsbeschreibung zu erstellen, werden Ihre Nutzereinstellungen und -daten verarbeitet. Hierbei
                können wir nicht ausschließen, dass Google Server in den USA einsetzt.
              </p>
              <p className='p'>
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt in der Optimierung
                der Funktionalität unseres Internetauftritts.
              </p>
              <p className='p'>
                Durch die so hergestellte Verbindung zu Google kann Google ermitteln, von welcher Website Ihre Anfrage
                gesendet worden ist und an welche IP-Adresse die Anfahrtsbeschreibung zu übermitteln ist.
              </p>
              <p className='p'>
                Sofern Sie mit dieser Verarbeitung nicht einverstanden sind, haben Sie die Möglichkeit, die Installation
                der Cookies durch die entsprechenden Einstellungen in Ihrem Internet-Browser zu verhindern. Einzelheiten
                hierzu finden Sie vorstehend unter dem Punkt „Cookies“.
              </p>
              <p className='p'>
                Zudem erfolgt die Nutzung von Google Maps sowie der über Google Maps erlangten Informationen nach den
                Google-Nutzungsbedingungen https://policies.google.com/terms?gl=DE&hl=de und den Geschäftsbedingungen
                für Google Maps https://www.google.com/intl/de_de/help/terms_maps.html.
              </p>
              <p className='p'>
                Überdies bietet Google unter https://adssettings.google.com/authenticated
                https://policies.google.com/privacy weitergehende Informationen an.
              </p>
            </div>

            <div>
              <h3 className='h3'>Google Fonts</h3>
              <p className='p'>
                In unserem Internetauftritt setzen wir Google Fonts zur Darstellung externer Schriftarten ein. Es
                handelt sich hierbei um einen Dienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
                Irland, nachfolgend nur „Google“ genannt.
              </p>
              <p className='p'>
                Um die Darstellung bestimmter Schriften in unserem Internetauftritt zu ermöglichen, wird bei Aufruf
                unseres Internetauftritts eine Verbindung zu dem Google-Server in den USA aufgebaut.
              </p>
              <p className='p'>
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt in der Optimierung
                und dem wirtschaftlichen Betrieb unseres Internetauftritts.
              </p>
              <p className='p'>
                Durch die bei Aufruf unseres Internetauftritts hergestellte Verbindung zu Google kann Google ermitteln,
                von welcher Website Ihre Anfrage gesendet worden ist und an welche IP-Adresse die Darstellung der
                Schrift zu übermitteln ist.
              </p>
              <p className='p'>
                Google bietet unter https://adssettings.google.com/authenticated https://policies.google.com/privacy
                weitere Informationen an und zwar insbesondere zu den Möglichkeiten der Unterbindung der Datennutzung.
              </p>
            </div>

            <div>
              <h3 className='h3'>FontAwesome</h3>
              <p className='p'>
                Um Schriften und visuelle Elemente unseres Internetauftritts darstellen zu können, setzen wir die
                externen Schriftarten von FontAwesome ein. Bei FontAwesome handelt es sich um einen Dienst der
              </p>
              <p className='p'>
                Fonticons Inc., 6 Porter Road, Apartment 3R, Cambridge, MA 02140, USA, nachfolgend nur „FontAwesome“
                genannt.
              </p>
              <p className='p'>
                Bei dem Aufruf unseres Internetauftritts wird eine Verbindung zum Server von FontAwesome in den USA
                aufgebaut, um so die Darstellung von Schriften und visuellen Elemente zu ermöglichen und zu
                aktualisieren.
              </p>
              <p className='p'>
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt in der Optimierung
                und dem wirtschaftlichen Betrieb unseres Internetauftritts.
              </p>
              <p className='p'>
                Durch die bei Aufruf unseres Internetauftritts hergestellte Verbindung zum Server von FontAwesome kann
                FontAwesome ermitteln, von welcher Website Ihre Anfrage gesendet worden ist und an welche IP-Adresse die
                Darstellung der Schrift zu übermitteln ist.
              </p>
              <p className='p'>
                FontAwesome bietet unter https://fontawesome.com/privacy weitere Informationen an und zwar insbesondere
                zu den Möglichkeiten der Unterbindung der Datennutzung.
              </p>
            </div>

            <div>
              <h3 className='h3'>YouTube</h3>
              <p className='p'>
                In unserem Internetauftritt setzen wir YouTube ein. Hierbei handelt es sich um ein Videoportal der
                YouTube LLC., 901 Cherry Ave., 94066 San Bruno, CA, USA, nachfolgend nur „YouTube“ genannt.
              </p>
              <p className='p'>
                YouTube ist ein Tochterunternehmen der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
                Irland, nachfolgend nur „Google“ genannt.
              </p>
              <p className='p'>
                Wir nutzen YouTube im Zusammenhang mit der Funktion „Erweiterter Datenschutzmodus“, um Ihnen Videos
                anzeigen zu können. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt
                in der Qualitätsverbesserung unseres Internetauftritts. Die Funktion „Erweiterter Datenschutzmodus“
                bewirkt laut Angaben von YouTube, dass die nachfolgend noch näher bezeichneten Daten nur dann an den
                Server von YouTube übermittelt werden, wenn Sie ein Video auch tatsächlich starten.
              </p>
              <p className='p'>
                Ohne diesen „Erweiterten Datenschutz“ wird eine Verbindung zum Server von YouTube in den USA
                hergestellt, sobald Sie eine unserer Internetseiten, auf der ein YouTube-Video eingebettet ist,
                aufrufen.
              </p>
              <p className='p'>
                Diese Verbindung ist erforderlich, um das jeweilige Video auf unserer Internetseite über Ihren
                Internet-Browser darstellen zu können. Im Zuge dessen wird YouTube zumindest Ihre IP-Adresse, das Datum
                nebst Uhrzeit sowie die von Ihnen besuchte Internetseite erfassen und verarbeiten. Zudem wird eine
                Verbindung zu dem Werbenetzwerk „DoubleClick“ von Google hergestellt.
              </p>
              <p className='p'>
                Sollten Sie gleichzeitig bei YouTube eingeloggt sein, weist YouTube die Verbindungsinformationen Ihrem
                YouTube-Konto zu. Wenn Sie das verhindern möchten, müssen Sie sich entweder vor dem Besuch unseres
                Internetauftritts bei YouTube ausloggen oder die entsprechenden Einstellungen in Ihrem
                YouTube-Benutzerkonto vornehmen.
              </p>
              <p className='p'>
                Zum Zwecke der Funktionalität sowie zur Analyse des Nutzungsverhaltens speichert YouTube dauerhaft
                Cookies über Ihren Internet-Browser auf Ihrem Endgerät. Falls Sie mit dieser Verarbeitung nicht
                einverstanden sind, haben Sie die Möglichkeit, die Speicherung der Cookies durch eine Einstellung in
                Ihrem Internet-Browsers zu verhindern. Nähere Informationen hierzu finden Sie vorstehend unter
                „Cookies“.
              </p>
              <p className='p'>
                Weitergehende Informationen über die Erhebung und Nutzung von Daten sowie Ihre diesbezüglichen Rechte
                und Schutzmöglichkeiten hält Google in den unter https://policies.google.com/privacy abrufbaren
                Datenschutzhinweisen bereit.
              </p>
            </div>

            <div>
              <p className='p'>
                <a
                  href='https://www.ratgeberrecht.eu/leistungen/muster-datenschutzerklaerung.html'
                  target='_blank'
                  rel='noreferrer noopener'
                >
                  Muster-Datenschutzerklärung
                </a>{' '}
                der{' '}
                <a
                  href='https://www.ratgeberrecht.eu/leistungen/muster-datenschutzerklaerung.html'
                  target='_blank'
                  rel='noreferrer noopener'
                >
                  Anwaltskanzlei Weiß & Partner
                </a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DataPrivacy;
